import React, {useRef} from "react"
import cx from "classnames"
import {SecondaryButton} from "components/buttons"
import style from "./ExportTranscriptButton.module.css"
import {Dropdown, Menu} from "antd"

type Props = {
    className?: string
    upperCaseLabel?: boolean
    classNameButton?: string
    classNameDropdown?: string
    label?: string
    subLabel?: string
    disabled?: boolean
    types?: Array<{type: string; label: string}>
    onSelect?: (type: string) => void
    onClick?: () => void
    isLoading?: boolean
    extraLabel?: string
}

export const ExportTranscriptButton = ({
    classNameDropdown,
    upperCaseLabel = true,
    className,
    classNameButton,
    label = "EXPORT",
    subLabel,
    onSelect,
    disabled,
    types = [],
    onClick,
    extraLabel,
    isLoading
}: Props) => {
    const ref = useRef(null)

    const handleOptionSelect = (type: string) => () => {
        onSelect?.(type)
    }
    const menu = (
        <Menu className={cx(style.dropdown, classNameDropdown)} style={{borderRadius: 10}}>
            {types.map((menuAction, index) => (
                <Menu.Item key={index} className={style.dropdownItem} onClick={handleOptionSelect(menuAction.type)}>
                    <span className={style.dropdownItem}>{menuAction.label}</span>
                </Menu.Item>
            ))}
        </Menu>
    )

    if (onClick) {
        return (
            <div className={cx(style.wrapper, className)} ref={ref}>
                <SecondaryButton
                    disabled={disabled}
                    uppercase={upperCaseLabel}
                    className={classNameButton}
                    loading={isLoading}
                    onClick={onClick}>
                    <span className={style.titleReportProgress}>{label}</span>
                    {subLabel ? <p className={style.subTitleReportProgress}>{subLabel}</p> : null}
                </SecondaryButton>
            </div>
        )
    }

    return (
        <Dropdown overlay={menu} disabled={disabled} trigger={["click"]}>
            <div className={cx(style.wrapper, className)} ref={ref}>
                <SecondaryButton
                    disabled={disabled}
                    loading={isLoading}
                    uppercase={upperCaseLabel}
                    className={classNameButton}>
                    <span className={style.titleReportProgress}>{label}</span>
                    {subLabel ? <p className={style.subTitleReportProgress}>{subLabel}</p> : null}
                    {extraLabel ? <p className={style.extraLabel}>{extraLabel}</p> : null}
                </SecondaryButton>
            </div>
        </Dropdown>
    )
}
